import React from 'react'

type IconProps = {
  icon?: string
  className?: string
  sel?: string
  style?: Record<string, string>
} & React.SVGProps<SVGSVGElement>

const IS_64PX_ICON_REGEX = /64px/
export const IS_FILL_ICON_REGEX = /-fill/

export const Icon = (props: IconProps) => {
  const { className, sel, icon = '' } = props
  return (
    <svg
      aria-hidden='true'
      role='img'
      focusable='false'
      className={`${className} ${
        IS_64PX_ICON_REGEX.test(icon) ? 'is-64' : 'is-16'
      }`}
      xmlns='http://www.w3.org/2000/svg'
      data-sel={sel}
      {...props}>
      <use href={`/nr-assets/icon-library-v5.svg/#${icon}`} />
    </svg>
  )
}

export default Icon
